import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import {
  CreateAccountAPI,
  CreateCustomerPaymentApi,
  CreateSupplierPaymentApi,
} from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import CustomerSelector from "../Selector/CustomerSelector";
import { fetchCustomerPayments } from "../../store/Slices/CustomerPaymentSlice";
import CustomTabs from "../Tabs/CustomTabs";
import CompanySelector from "../Selector/CompanySelector";
import TypeSelector from "../Selector/TypeSelector";
import PaymentTypeSelector from "../Selector/PaymentTypeSelector";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { fetchAccounts } from "../../store/Slices/AccountSlice";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId } = userData;

const AddAccountModal = ({ Open, setOpen }) => {
  const [bankName, setBankName] = useState("");
  const [bankNumber, setBankNumber] = useState("");

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Customer");

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let payload = {
      account_name: bankName,
      account_no: bankNumber,
      branchId: branchId,
    };

    if (!bankName || !bankNumber) WarningToast("Valid Bank Details Required");
    else {
      try {
        let response = await CreateAccountAPI({
          ...payload,
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Account added successfully");
          dispatch(fetchAccounts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        ErrorToast(err.response.data.error?.msg);
        // ErrorToast("Failed to add payment");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Account
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <AuthInput
              label="Bank Name"
              placeholder="Enter Bank Name"
              Value={bankName}
              setValue={setBankName}
            />
            <AuthInput
              label="Bank Number"
              placeholder="Enter Bank Number"
              Type="number"
              Value={bankNumber}
              setValue={setBankNumber}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Account"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddAccountModal;
